module.exports = __webpack_public_path__ + "static/media/slider6.0230d3eb.jpg";